import React, { useState, useEffect, useCallback } from "react";
import style from "./sidebar.module.css";
import userIcon from "../../assets/images/userico.png";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Sidebar() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [visiblem, setVisiblem] = useState(false);
  const [visiblemad, setVisiblemad] = useState(false);
  const [visiblefr, setVisiblefr] = useState(false);
  const [visibler, setVisibler] = useState(false);
  const [setClass, setSetClass] = useState(false);
  const [visiblechef, setVisiblechef] = useState(false);
  const [visibleho, setVisibleho] = useState(false);
  const [visiblepromo, setVisiblepromo] = useState(false);
  const [visiblevendorhub, setVisiblevendorhub] = useState(false);
  const location = useLocation();
  const pathName = location.pathname;

  const [{ adminName, rolePermissions }] = useState(() => {
    const authData = JSON.parse(sessionStorage.getItem("authData"));
      return {
        adminName: authData ? authData.adminName : "",
        rolePermissions: authData ? authData.adminRole.permissions : "",
      };
  });

  const handClick = useCallback(() => {
    setVisible((prev) => !prev);
    setVisiblem(false);
    setVisiblemad(false);
    setVisiblefr(false);
    setVisibler(false);
  }, []);

  const handClickmaster = useCallback(() => {
    setVisiblem((prev) => !prev);
    setVisible(false);
    setVisiblemad(false);
    setVisiblefr(false);
    setVisibler(false);
  }, []);

  const handClickfreesample = useCallback(() => {
    setVisiblefr((prev) => !prev);
    setVisible(false);
    setVisiblem(false);
    setVisiblemad(false);
    setVisibler(false);
  }, []);

  const handClickadmin = useCallback(() => {
    setVisiblemad((prev) => !prev);
    setVisible(false);
    setVisiblem(false);
    setVisiblefr(false);
    setVisibler(false);
  }, []);

  const handClickemailcustomer = useCallback(() => {
    setVisibler((prev) => !prev);
    setVisible(false);
    setVisiblem(false);
    setVisiblefr(false);
    setVisiblemad(false);
    setVisiblevendorhub(false);
  }, []);

  const handClickvendorhub = useCallback(() => {
    setVisiblevendorhub((prev) => !prev);
    setVisible(false);
    setVisiblem(false);
    setVisiblefr(false);
    setVisiblemad(false);
    setVisibler(false);
  }, []);

  const handClickchef = useCallback(() => {
    setVisiblechef((prev) => !prev);
    setVisible(false);
    setVisiblem(false);
    setVisiblemad(false);
    setVisiblefr(false);
    setVisibler(false);
    setVisiblevendorhub(false);
  }, []);

  const handClickho = useCallback(() => {
    setVisibleho((prev) => !prev);
    setVisible(false);
    setVisiblem(false);
    setVisiblemad(false);
    setVisiblefr(false);
    setVisibler(false);
    setVisiblechef(false);
    setVisiblevendorhub(false);
  }, []);

  const handClickpromo = useCallback(() => {
    setVisiblepromo((prev) => !prev);
    setVisible(false);
    setVisiblem(false);
    setVisiblemad(false);
    setVisiblefr(false);
    setVisibler(false);
    setVisiblevendorhub(false);
    setVisiblechef(false);
    setVisibleho(false);
  }, []);

  const handleAddClass = useCallback(() => {
    setSetClass((prev) => !prev);
  }, []);

  const logout = useCallback((e) => {
    sessionStorage.clear();
    window.location.href = "/";
  }, []);

  const getpathlist = useCallback((pathName) => {
    if (
      pathName === "/holiday" ||
      pathName === "/holiday/add/" ||
      pathName === "/settings" ||
      pathName === "/accountdetails" ||
      pathName === "/social-links" ||
      pathName === "/site-settings" ||
      pathName === "/login-visibility" ||
      pathName === "/category-visibility" ||
      pathName === "/notification" ||
      pathName === "/clearsession" ||
      pathName === "/allergens" ||
      pathName === "/allergens/add/" ||
      pathName === `/allergens/edit/${pathName.split("/").at(-1)}` ||
      pathName === "/ingredients" ||
      pathName === `/ingredients/edit/${pathName.split("/").at(-1)}` ||
      pathName === "/ingredients/add/" ||
      pathName === "/stripe-paymentkey" ||
      pathName === "/freecode" ||
      pathName === "/freecode/add/"
    ) {
      setVisible(true);
    }
    if (
      [
        `/master-entry/productgroup`,
        `/master-entry/add/productgroup`,
        `/master-entry/edit/productgroup/${pathName.split("/").at(-1)}`,
        `/master-entry/taxcode`,
        `/master-entry/add/taxcode`,
        `/master-entry/edit/taxcode/${pathName.split("/").at(-1)}`,
        `/master-entry/suitablefor`,
        `/master-entry/add/suitablefor`,
        `/master-entry/edit/suitablefor/${pathName.split("/").at(-1)}`,
        `/master-entry/sectors`,
        `/master-entry/add/sectors`,
        `/master-entry/edit/sectors/${pathName.split("/").at(-1)}`,
        `/depot`,
        `/depot/add`,
        `/depot/edit/${pathName.split("/").at(-1)}`,
        `/restrictedaccountcode/accountcode`,
        `/restrictedaccountcode/accountcode/add/`,
        `/restrictedaccountcode/accountcode/edit/${pathName.split("/").at(-2)}/`,
        `/masteraccountcode/accountcode`,
        `/masteraccountcode/accountcode/add/`,
        `/masteraccountcode/accountcode/edit/${pathName.split("/").at(-2)}/`,
        `/kitchenaccount`,
        `/kitchenaccount/add/`,
        `/kitchenaccount/edit/${pathName.split("/").at(-2)}/`,
      ].includes(pathName)
    ) {
      setVisiblem(true);
      setVisible(false);
    }
    if (
      [
        `/role/`,
        `/role/addRoles/`,
        `/role/editRoles/${pathName.split("/").at(-1)}`,
        `/account`,
        `/account/adduser`,
      ].includes(pathName)
    ) {
      setVisiblemad(true);
      setVisible(false);
    }
    if (
      [
        `/freesample/freeorders`,
        `/freesample/freecode`,
        `/freesample/freecode/add/`,
        `/freesample/freecode/edit/${pathName.split("/").at(-1)}`,
      ].includes(pathName)
    ) {
      setVisiblefr(true);
      setVisible(false);
    }
    if (
      [
        `/email-configuration`,
        `/email-configuration/add`,
        `/email-configuration/edit`,
      ].includes(pathName)
    ) {
      setVisibler(true);
      setVisible(false);
    }
    if (
      [
        `/email-campaign`,
        `/email-campaign/add`,
        `/email-campaign/edit`,
      ].includes(pathName)
    ) {
      setVisibler(true);
      setVisible(false);
    }
    if (
      [
        `/vendorhub/faq`,
        `/vendorhub/faq/add`,
        `/vendorhub/faq/edit/${pathName.split("/").at(-1)}`,
        "/vendorhub/food-service-partner-lead-forms",
        "/vendorhub/food-service-partner-auth-email",
        "/vendorhub/food-service-partner",
      ].includes(pathName)
    ) {
      setVisiblevendorhub(true);
      setVisible(false);
    }
    if (
      [
        `/email-logs`,
        `/email-settings`,
        `/loggedinnotordered-emailcampaign`,
        `/abandonedcart-emailcampaign`,
        `/unsubscribed`,
      ].includes(pathName)
    ) {
      setVisibler(true);
      setVisible(false);
    }
    if (
      [
        "/development-chef",
        "/development-chef/add",
        `/development-chef/edit/${pathName.split("/").at(-1)}`,
        "/chef/accountcode",
        "/chef/accountcode/add/",
        `/chef/accountcode/edit/${pathName.split("/").at(-2)}/`,
      ].includes(pathName)
    ) {
      setVisiblechef(true);
      setVisible(false);
    }
    if (
      [
        "/headoffice/account",
        "/headoffice/account/add/",
        `/headoffice/account/edit/${pathName.split("/").at(-2)}/`,
        "/headoffice/accountcode",
        "/headoffice/accountcode/add/",
        `/headoffice/accountcode/edit/${pathName.split("/").at(-2)}/`,
      ].includes(pathName)
    ) {
      setVisibleho(true);
      setVisible(false);
    }
    if (
      [
        "/promooffers",
        "/promooffers/add",
        `/promooffers/edit/${pathName.split("/").at(-1)}`,
        "/promo-pinsa-settings",
        "/promooffers/feedback-form",
      ].includes(pathName)
    ) {
      setVisiblepromo(true);
      setVisible(false);
    }
  }, []);

  useEffect(() => {
    getpathlist(pathName);
  }, [pathName]);

  return (
    <>
      <div className={`${style.dashRight} ${setClass ? "open" : ""}`}>
        <div className={`${style.sideNav}`}>
          <div className={style.innside}>
            <div className={style.userIco}>
              <span>
                <img src={userIcon} alt="user" />
              </span>
              {adminName && <h5 className={style.title}>{adminName}</h5>}
            </div>
            <a className={style.menuOpen} onClick={handleAddClass}>
              <span>
                <i className={`fa fa-angle-left`}></i>
              </span>
            </a>
            <nav>
              <ul>
                {rolePermissions.includes("manage_dashboard") && (
                  <li className={pathName === "/dashboard" ? "active" : ""}>
                    <Link to="/dashboard">
                      <i className={`fa fa-th-large`}></i>{" "}
                      <span className={style.menuTxt}>{t("dashboard_txt")}</span>
                    </Link>
                  </li>
                )}
                {rolePermissions.includes("manage_products") && (
                  <li className={pathName === "/products" ? "active" : ""}>
                    {" "}
                    <Link to="/products">
                      <i className={`fa fa-archive`}></i>{" "}
                      <span className={style.menuTxt}>{t("products_txt")}</span>
                    </Link>
                  </li>
                )}
                {/*{rolePermissions.includes("manage_product_access_request") && (
                  <li
                    className={pathName === "/product-access-requests" ? "active" : ""}
                  >
                    <Link to="/product-access-requests">
                      <i className="fa fa-lock"></i>
                      <span className={style.menuTxt}>
                        {t("product_access_requests_txt")}
                      </span>
                    </Link>
                  </li>
                )}*/}
                {rolePermissions.includes("manage_freeproducts") && (
                  <li
                    className={
                      pathName === "/freeproducts" ||
                      pathName === "/freeproducts/addfreeproducts" ||
                      pathName ===
                        `/freeproducts/editfreeproducts/${pathName
                          .split("/")
                          .at(-1)}`
                        ? "active"
                        : ""
                    }
                  >
                    {" "}
                    <Link to="/freeproducts">
                      <i className={`fa fa-sliders`}></i>{" "}
                      <span className={style.menuTxt}>{t("free_product_setup_txt")}</span>
                    </Link>
                  </li>
                )}
                {rolePermissions.includes("manage_newproducts") && (
                  <li
                    className={
                      pathName === "/newproducts" ||
                      pathName === "/newproducts/add" ||
                      pathName ===
                        `/newproducts/edit/${pathName.split("/").at(-1)}`
                        ? "active"
                        : ""
                    }
                  >
                    {" "}
                    <Link to="/newproducts">
                      <i className={`fa fa-cube`}></i>{" "}
                      <span className={style.menuTxt}>{t("new_products_txt")}</span>
                    </Link>
                  </li>
                )}
                {rolePermissions.includes("manage_promotions") && (
                  <li
                    className={
                      pathName === "/promotions" ||
                      pathName === "/promotions/add" ||
                      pathName ===
                        `/promotions/edit/${pathName.split("/").at(-1)}`
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/promotions">
                      <i className={`fa fa-flag`}></i>{" "}
                      <span className={style.menuTxt}>{t("promotion_banner_txt")}</span>
                    </Link>
                  </li>
                )}
                {rolePermissions.includes("manage_promooffers") && (
                  <li
                    className={`${style.dropMenu} ${
                      visiblepromo ? "active show" : ""
                    }`}
                  >
                    <a href={void 0} onClick={handClickpromo}>
                      <i className={`fa fa-gift`}></i>
                      <span className={style.menuTxt}>{t("promo_offer_txt")}</span>
                      <i className="fa fa-angle-down"></i>
                    </a>
                    <div className={style.submenu}>
                      <ul>
                        {/* Promo Offers */}
                        <li
                          className={
                            pathName === "/promooffers" ||
                            pathName === "/promooffers/add" ||
                            pathName ===
                              `/promooffers/edit/${pathName.split("/").at(-1)}`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/promooffers">
                            <i className={`fa fa-list-ul`}></i>
                            <span className={style.menuTxt}>
                              {t("promo_offer_management_txt")}
                            </span>
                          </Link>
                        </li>
                        {/* Promo Offers Settings */}
                        <li
                          className={
                            pathName === "/promo-pinsa-settings" ? "active" : ""
                          }
                        >
                          <Link to="/promo-pinsa-settings">
                            <i className={`fa fa-toggle-on`}></i>
                            <span className={style.menuTxt}>
                              {t("promo_pinsa_email_settings_txt")}
                            </span>
                          </Link>
                        </li>
                        {/* Promo Feedback Form */}
                        <li
                          className={
                            pathName === "/promooffers/feedback-form"
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/promooffers/feedback-form">
                            <i className={`fa fa-comment`}></i>
                            <span className={style.menuTxt}>
                              {t("promopinsa_header")}
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                )}
                {rolePermissions.includes("manage_customers") && (
                  <li className={pathName === "/vendors" ? "active" : ""}>
                    <Link to="/vendors">
                      <i className={`fa fa-users`}></i>{" "}
                      <span className={style.menuTxt}>
                        {t("customers_txt")}
                      </span>
                    </Link>
                  </li>
                )}
                {rolePermissions.includes("manage_foodservicepartners") && (
                  <>
                    <li
                      className={`${style.dropMenu} ${
                        visiblevendorhub ? "active show" : ""
                      }`}
                    >
                      <a href={void 0} onClick={handClickvendorhub}>
                        <i className={` fa fa-hdd-o`}></i>{" "}
                        <span className={style.menuTxt}>
                          {t("food_service_partner_txt")}
                        </span>{" "}
                        <i className="fa fa-angle-down"></i>
                      </a>
                      <div className={style.submenu}>
                        <ul>
                          <li
                            className={
                              pathName ===
                              "/vendorhub/food-service-partner-lead-forms"
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/vendorhub/food-service-partner-lead-forms">
                              <i className={`fa fa-user-plus`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("customer_lead_forms_txt")}
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName ===
                              "/vendorhub/food-service-partner-auth-email"
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/vendorhub/food-service-partner-auth-email">
                              <i className={`fa fa-check-circle`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("food_service_partner_verification_email_txt")}
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName === "/vendorhub/food-service-partner"
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/vendorhub/food-service-partner">
                              <i className={`fa fa-briefcase`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("vendor_landing_cms_editor_title_txt")}
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName === "/vendorhub/faq" ||
                              pathName === "/vendorhub/faq/add" ||
                              pathName ===
                                `/vendorhub/faq/edit/${pathName
                                  .split("/")
                                  .at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/vendorhub/faq">
                              <i className={`fa fa-question-circle`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("faq_management_txt")}
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </>
                )}
                {rolePermissions.includes("manage_orders") && (
                  <li className={pathName === "/orders" ? "active" : ""}>
                    <Link to="/orders">
                      <i className={`fa fa-shopping-cart`}></i>{" "}
                      <span className={style.menuTxt}>
                        {t("order_txt")}
                      </span>
                    </Link>
                  </li>
                )}
                {rolePermissions.includes("manage_foodsolutions") && (
                  <>
                    <li
                      className={`${style.dropMenu} ${
                        visiblefr ? "active show" : ""
                      }`}
                    >
                      <a href={void 0} onClick={handClickfreesample}>
                        <i className={`fa fa-coffee`}></i>{" "}
                        <span className={style.menuTxt}>
                          {t("food_solution_txt")}
                        </span>{" "}
                        <i className="fa fa-angle-down"></i>
                      </a>
                      <div className={style.submenu}>
                        <ul>
                          <li
                            className={
                              pathName === "/freesample/freeorders"
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/freesample/freeorders">
                              <i className={`fa fa-cart-arrow-down`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("free_sample_order_txt")}
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName === "/freesample/freecode" ||
                              pathName === "/freesample/freecode/add/" ||
                              pathName ===
                                `/freesample/freecode/edit/${pathName
                                  .split("/")
                                  .at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/freesample/freecode">
                              <i className={`fa fa-address-book-o`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("free_sample_code_txt")}
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </>
                )}
                {rolePermissions.includes("manage_stripelog") && (
                  <li
                    className={
                      pathName === "/stripe-paymentlog" ? "active" : ""
                    }
                  >
                    <Link to="/stripe-paymentlog">
                      <i className={`fa fa-cc-stripe`}></i>{" "}
                      <span className={style.menuTxt}>
                        {t("stripe_payment_log_txt")}
                      </span>
                    </Link>
                  </li>
                )}
                {rolePermissions.includes("manage_masterentry") && (
                  <li
                    className={`${style.dropMenu} ${
                      visiblem ? "active show" : ""
                    }`}
                  >
                    <a href={void 0} onClick={handClickmaster}>
                      <i className={`fa fa-trophy`}></i>{" "}
                      <span className={style.menuTxt}>
                        {t("master_entry_txt")}
                      </span>{" "}
                      <i className="fa fa-angle-down"></i>
                    </a>
                    <div className={style.submenu}>
                      <ul>
                        <li
                          className={
                            pathName === "/master-entry/productgroup" ||
                            pathName === "/master-entry/add/productgroup" ||
                            pathName ===
                              `/master-entry/edit/productgroup/${pathName
                                .split("/")
                                .at(-1)}`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/master-entry/productgroup">
                            <i className={`fa fa-database`}></i>{" "}
                            <span className={style.menuTxt}>
                              {t("product_group_txt")}
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            pathName === "/master-entry/taxcode" ||
                            pathName === "/master-entry/add/taxcode" ||
                            pathName ===
                              `/master-entry/edit/taxcode/${pathName
                                .split("/")
                                .at(-1)}`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/master-entry/taxcode">
                            <i className={`fa fa-barcode`}></i>{" "}
                            <span className={style.menuTxt}>
                              {t("tax_code_txt")}
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            pathName === "/master-entry/suitablefor" ||
                            pathName === "/master-entry/add/suitablefor" ||
                            pathName ===
                              `/master-entry/edit/suitablefor/${pathName
                                .split("/")
                                .at(-1)}`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/master-entry/suitablefor">
                            <i className={`fa fa-flag-o`}></i>{" "}
                            <span className={style.menuTxt}>
                              {t("suitable_for_txt")}
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            pathName === "/master-entry/sectors" ||
                            pathName === "/master-entry/add/sectors" ||
                            pathName ===
                              `/master-entry/edit/sectors/${pathName
                                .split("/")
                                .at(-1)}`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/master-entry/sectors">
                            <i className={`fa fa-industry`}></i>{" "}
                            <span className={style.menuTxt}>
                              {t("sector_txt")}
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            pathName === "/depot" ||
                            pathName === "/depot/add" ||
                            pathName ===
                              `/depot/edit/${pathName.split("/").at(-1)}`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/depot">
                            <i className={`fa fa-map-marker`}></i>{" "}
                            <span className={style.menuTxt}>
                              {t("depots_txt")}
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            pathName === "/restrictedaccountcode/accountcode" ||
                            pathName ===
                              "/restrictedaccountcode/accountcode/add/" ||
                            pathName ===
                              `/restrictedaccountcode/accountcode/edit/${pathName
                                .split("/")
                                .at(-2)}/`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/restrictedaccountcode/accountcode">
                            <i className={`fa fa-lock`}></i>{" "}
                            <span className={style.menuTxt}>
                              {t("restricted_account_txt")}
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            pathName === "/masteraccountcode/accountcode" ||
                            pathName ===
                              "/masteraccountcode/accountcode/add/" ||
                            pathName ===
                              `/masteraccountcode/accountcode/edit/${pathName
                                .split("/")
                                .at(-2)}/`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/masteraccountcode/accountcode">
                            <i className={`fa fa-shield`}></i>{" "}
                            <span className={style.menuTxt}>
                              {t("master_login_accounts_txt")}
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            pathName === "/kitchenaccount" ||
                            pathName === "/kitchenaccount/add/" ||
                            pathName ===
                              `/kitchenaccount/edit/${pathName
                                .split("/")
                                .at(-2)}/`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/kitchenaccount">
                            <i className={`fa fa-tags`}></i>{" "}
                            <span className={style.menuTxt}>
                              {t("kitchen_accounts_txt")}
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                )}
                {rolePermissions.includes("manage_chefs") && (
                  <li
                    className={`${style.dropMenu} ${
                      visiblechef ? "active show" : ""
                    }`}
                  >
                    <a href={void 0} onClick={handClickchef}>
                      <i className="fa fa-cutlery"></i>
                      <span className={style.menuTxt}>
                        {t("developement_chef_txt")}
                      </span>
                      <i className="fa fa-angle-down"></i>
                    </a>
                    <div className={style.submenu}>
                      <ul>
                        <li
                          className={
                            pathName === "/development-chef" ||
                            pathName === "/development-chef/add" ||
                            pathName ===
                              `/development-chef/edit/${pathName
                                .split("/")
                                .at(-1)}`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/development-chef">
                            <i className={`fa fa-user-circle`}></i>{" "}
                            <span className={style.menuTxt}>
                              {t("chef_accounts_txt")}
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            pathName === "/chef/accountcode" ||
                            pathName === "/chef/accountcode/add/" ||
                            pathName ===
                              `/chef/accountcode/edit/${pathName.split("/").at(-2)}/`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/chef/accountcode">
                            <i className="fa fa-user-secret"></i>
                            <span className={style.menuTxt}>
                              {t("restricted_chef_accounts_txt")}
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                )}
                {rolePermissions.includes("manage_ho") && (
                  <li
                    className={`${style.dropMenu} ${
                      visibleho ? "active show" : ""
                    }`}
                  >
                    <a href={void 0} onClick={handClickho}>
                      <i className="fa fa-building"></i>
                      <span className={style.menuTxt}>
                        {t("head_office_txt")}
                      </span>
                      <i className="fa fa-angle-down"></i>
                    </a>
                    <div className={style.submenu}>
                      <ul>
                        <li
                          className={
                            pathName === "/headoffice/account" ||
                            pathName === "/headoffice/account/add/" ||
                            pathName ===
                              `/headoffice/account/edit/${pathName
                                .split("/")
                                .at(-2)}/`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/headoffice/account">
                            <i className="fa fa-university"></i>
                            <span className={style.menuTxt}>
                              {t("ho_accounts_txt")}
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            pathName === "/headoffice/accountcode" ||
                            pathName === "/headoffice/accountcode/add/" ||
                            pathName ===
                              `/headoffice/accountcode/edit/${pathName
                                .split("/")
                                .at(-2)}/`
                              ? "active"
                              : ""
                          }
                        >
                          <Link to="/headoffice/accountcode">
                            <i className="fa fa-id-badge"></i>
                            <span className={style.menuTxt}>
                              {t("restricted_ho_accounts_txt")}
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                )}
                {(rolePermissions.includes("manage_users") ||
                  rolePermissions.includes("manage_roles")) && (
                  <li
                    className={`${style.dropMenu} ${
                      visiblemad ? "active show" : ""
                    }`}
                  >
                    <a href={void 0} onClick={handClickadmin}>
                      <i className="fa fa-address-book"></i>
                      <span className={style.menuTxt}>{t("admin_user_txt")}</span>
                      <i className="fa fa-angle-down"></i>
                    </a>
                    <div className={style.submenu}>
                      <ul>
                        {/* Show Users only if has manage_users */}
                        {rolePermissions.includes("manage_users") && (
                          <li
                            className={
                              pathName === "/account" ||
                              pathName === "/account/adduser"
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/account">
                              <i className="fa fa-user-o"></i>
                              <span className={style.menuTxt}>{t("user_txt")}</span>
                            </Link>
                          </li>
                        )}
                        {/* Show Roles only if has manage_roles */}
                        {rolePermissions.includes("manage_roles") && (
                          <li
                            className={
                              pathName === "/role/" ||
                              pathName === "/role/addRoles/" ||
                              pathName ===
                                `/role/editRoles/${pathName.split("/").at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/role/">
                              <i className="fa fa-level-up"></i>
                              <span className={style.menuTxt}>{t("role_txt")}</span>
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}
                {rolePermissions.includes("manage_emailcampaign") && (
                  <>
                    <li
                      className={`${style.dropMenu} ${
                        visibler ? "active show" : ""
                      }`}
                    >
                      <a href={void 0} onClick={handClickemailcustomer}>
                        <i className={`fa fa-envelope`}></i>{" "}
                        <span className={style.menuTxt}>{t("email_campaign_txt")}</span>{" "}
                        <i className="fa fa-angle-down"></i>
                      </a>
                      <div className={style.submenu}>
                        <ul>
                          {rolePermissions.includes("manage_emailcampaign") && (
                            <li
                              className={
                                pathName === "/email-configuration" ||
                                pathName === "/email-configuration/add" ||
                                pathName === `/email-configuration/edit`
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/email-configuration">
                                <i className={`fa fa-wrench`}></i>{" "}
                                <span className={style.menuTxt}>
                                  {t("email_configuration_title_txt")}
                                </span>
                              </Link>
                            </li>
                          )}
                          {rolePermissions.includes(
                            "manage_emailcampaign.runemail",
                          ) && (
                            <li
                              className={
                                pathName === "/email-campaign" ||
                                pathName === "/email-campaign/add" ||
                                pathName === "/email-campaign/edit"
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/email-campaign">
                                <i className="fa fa-calendar"></i>{" "}
                                <span className={style.menuTxt}>
                                  {t("email_campaign_management_title")}
                                </span>
                              </Link>
                            </li>
                          )}
                          {rolePermissions.includes(
                            "manage_emailcampaign.logs",
                          ) && (
                            <li
                              className={
                                pathName === "/email-logs" ? "active" : ""
                              }
                            >
                              <Link to="/email-logs">
                                <i className={`fa fa-file-text-o`}></i>{" "}
                                <span className={style.menuTxt}>
                                  {t("email_log_title_txt")}
                                </span>
                              </Link>
                            </li>
                          )}
                          {rolePermissions.includes(
                            "manage_emailcampaign.runemail",
                          ) && (
                            <>
                              <li
                                className={
                                  pathName === "/unsubscribed" ? "active" : ""
                                }
                              >
                                <Link to="/unsubscribed">
                                  <i className="fa fa-times-circle"></i>{" "}
                                  <span className={style.menuTxt}>
                                    {t("unsubscribed_customer_txt")}
                                  </span>
                                </Link>
                              </li>
                            </>
                          )}
                          {rolePermissions.includes("manage_emailcampaign") && (
                            <li
                              className={
                                pathName === "/email-settings" ? "active" : ""
                              }
                            >
                              <Link to="/email-settings">
                                <i className={`fa fa-cogs`}></i>{" "}
                                <span className={style.menuTxt}>
                                  {t("email_setting_txt")}
                                </span>
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    </li>
                  </>
                )}
                {rolePermissions.includes("manage_settings") && (
                  <>
                    <li
                      className={`${style.dropMenu} ${
                        visible ? "active show" : ""
                      }`}
                    >
                      <a href={void 0} onClick={handClick}>
                        <i className={`fa fa-gear`}></i>{" "}
                        <span className={style.menuTxt}>{t("setting_txt")}</span>{" "}
                        <i className="fa fa-angle-down"></i>
                      </a>
                      <div className={style.submenu}>
                        <ul>
                          <li
                            className={
                              pathName === "/holiday" ||
                              pathName === "/holiday/add/"
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/holiday">
                              <i className={`fa fa-calendar`}></i>{" "}
                              <span className={style.menuTxt}>{t("holiday_txt")}</span>
                            </Link>
                          </li>
                          <li
                            className={pathName === "/settings" ? "active" : ""}
                          >
                            <Link to="/settings">
                              <i className={`fa fa-wrench`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("website_maintenance_txt")}
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName === "/allergens" ||
                              pathName === "/allergens/add/" ||
                              pathName ===
                                `/allergens/edit/${pathName.split("/").at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/allergens">
                              <i className={`fa fa-industry`}></i>{" "}
                              <span className={style.menuTxt}>{t("allergens_txt")}</span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName === "/ingredients" ||
                              pathName === "/ingredients/add/" ||
                              pathName ===
                                `/ingredients/edit/${pathName
                                  .split("/")
                                  .at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/ingredients">
                              <i className={`fa fa-magic`}></i>{" "}
                              <span className={style.menuTxt}>{t("ingredient_txt")}</span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName === "/stripe-paymentkey" ? "active" : ""
                            }
                          >
                            <Link to="/stripe-paymentkey">
                              <i className={`fa fa-cc-stripe`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("stripe_payment_key_txt")}
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName === "/social-links" ? "active" : ""
                            }
                          >
                            <Link to="/social-links">
                              <i className={`fa fa-globe`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("social_link_txt")}
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName === "/notification" ? "active" : ""
                            }
                          >
                            <Link to="/notification">
                              <i className={`fa fa-bell`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("notification_txt")}
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName === "/clearsession" ? "active" : ""
                            }
                          >
                            <Link to="/clearsession">
                              <i className={`fa fa-remove`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("delete_session_txt")}
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName === "/site-settings" ? "active" : ""
                            }
                          >
                            <Link to="/site-settings">
                              <i className={`fa fa-gear`}></i>{" "}
                              <span className={style.menuTxt}>
                                {t("site_setting_txt")}
                              </span>
                            </Link>
                          </li>
                          {/* <li
                            className={
                              pathName === "/login-visibility" ? "active" : ""
                            }
                          >
                            <Link to="/login-visibility">
                              <i className="fa fa-bars"></i>
                              <span className={style.menuTxt}>
                                {t("login_visibility_settings_txt")}
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              pathName === "/category-visibility"
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/category-visibility">
                              <i className="fa fa-list"></i>
                              <span className={style.menuTxt}>
                                {t("category_visibility_txt")}
                              </span>
                            </Link>
                          </li> */}
                        </ul>
                      </div>
                    </li>
                  </>
                )}
              </ul>
            </nav>
            <div className={style.navBot}>
              <a href={void 0} onClick={(e) => logout(e)}>
                <i className={`fa fa-sign-out`}></i>{" "}
                <span className={style.menuTxt}>{t("logout_txt")}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(Sidebar);
